var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "stake",
    class: _vm.isMobile && 'wap'
  }, [_c('div', {
    staticClass: "stake-main"
  }, [_c('div', {
    staticClass: "home-tab-content-wrapper"
  }, [_c('div', {
    staticClass: "home-tab-content"
  }, [_c('div', {
    staticClass: "home-tab-item",
    class: {
      'home-tab-item-active': _vm.homeActivateIndex === 0
    },
    on: {
      "click": function ($event) {
        _vm.homeActivateIndex = 0;
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$lang('原創NFT')) + " ")]), _c('div', {
    staticClass: "home-tab-item",
    class: {
      'home-tab-item-active': _vm.homeActivateIndex === 1
    },
    on: {
      "click": function ($event) {
        _vm.homeActivateIndex = 1;
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$lang('映射NFT')) + " ")]), _c('div', {
    staticClass: "home-tab-item",
    class: {
      'home-tab-item-active': _vm.homeActivateIndex === 2
    },
    on: {
      "click": function ($event) {
        _vm.homeActivateIndex = 2;
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$lang('算力')) + " ")])])]), _vm.homeActivateIndex == 0 ? [_c('div', {
    staticClass: "s1"
  }, [_c('div', {
    staticClass: "s1-main"
  }, [_c('div', {
    staticClass: "s1-left"
  }, [_c('div', {
    staticClass: "video-box"
  }, [_c('video', {
    attrs: {
      "autoplay": "",
      "loop": "",
      "muted": "",
      "playsinline": ""
    },
    domProps: {
      "muted": true
    }
  }, [_c('source', {
    attrs: {
      "src": require('@images/video.mp4'),
      "type": "video/mp4"
    }
  })])])]), _c('div', {
    staticClass: "s1-right"
  }, [_c('div', {
    staticClass: "node-record-line"
  }, [_c('div', {
    staticClass: "s1__title"
  }, [_vm._v(_vm._s(_vm.$lang(`Purchase Node`)))]), _c('NodeRecord')], 1), _c('div', {
    staticClass: "s1-list"
  }, [_c('div', {
    staticClass: "s1-number"
  }, [_c('div', {
    staticClass: "btn-n",
    class: _vm.buyNum <= 1 && 'dis',
    on: {
      "click": _vm.onMin
    }
  }, [_vm._v("MIN")]), _c('div', {
    staticClass: "btn-m",
    class: _vm.buyNum <= 1 && 'dis',
    on: {
      "click": _vm.onSub
    }
  }, [_vm._v("-")]), _c('div', {
    staticClass: "s1-input"
  }, [_c('div', {
    staticClass: "s1-input-main"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.buyNum,
      expression: "buyNum"
    }],
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": _vm.buyNum
    },
    on: {
      "keyup": function ($event) {
        return _vm.buyNumKeyUp();
      },
      "input": function ($event) {
        if ($event.target.composing) return;
        _vm.buyNum = $event.target.value;
      }
    }
  })])]), _c('div', {
    staticClass: "btn-m",
    class: _vm.isMax && 'dis',
    on: {
      "click": _vm.onAdd
    }
  }, [_vm._v("+")]), _c('div', {
    staticClass: "btn-n",
    class: _vm.isMax && 'dis',
    on: {
      "click": _vm.onMax
    }
  }, [_vm._v("Max")])]), _vm.userInfo?.user?.must_inviter == 1 ? _c('div', {
    staticClass: "s1-inviter"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.inviter,
      expression: "inviter"
    }],
    attrs: {
      "type": "text",
      "placeholder": _vm.$lang('Enter Your Reference Address')
    },
    domProps: {
      "value": _vm.inviter
    },
    on: {
      "input": function ($event) {
        if ($event.target.composing) return;
        _vm.inviter = $event.target.value;
      }
    }
  }), _c('div', {
    staticClass: "bind-invite-button",
    on: {
      "click": function ($event) {
        return _vm.onConfirmBind();
      }
    }
  }, [_vm._v(_vm._s(_vm.$lang('Bind')))])]) : _vm._e(), _c('div', {
    staticClass: "s1-value"
  }, [_c('div', {
    staticClass: "s1-val"
  }, [_c('span', [_vm._v(_vm._s(_vm.$lang(`Total Amount: `)))]), _vm._v(_vm._s(_vm._f("toThousands")(_vm.priceLabel)) + " USDT ")])]), _c('div', {
    staticClass: "btn-box"
  }, [_vm.address ? [_c('div', {
    staticClass: "content-button-wrapper"
  }, [Number(_vm.nftSellInfo.startTime) > Number(_vm.nftSellInfo.nowTime) ? [_c('div', {
    staticClass: "content-button-wrapper"
  }, [_c('div', {
    staticClass: "btn-buy dis"
  }, [_vm._v(_vm._s(_vm.$lang(`Waiting to begin`)))])])] : Number(_vm.nftSellInfo.openTotalMint) <= Number(_vm.nftSellInfo.mintTotal) ? [_vm._v(" " + _vm._s(_vm.$lang(`Mint End`)) + " ")] : [!_vm.token_enough ? [_c('div', {
    staticClass: "btn-buy",
    on: {
      "click": function ($event) {
        return _vm.onBuy(1);
      }
    }
  }, [_vm._v(_vm._s(_vm.$lang(`USDT balance is insufficient`)))])] : [_vm.isApprove ? [_c('div', {
    staticClass: "content-button-wrapper",
    staticStyle: {
      "height": "100%"
    }
  }, [_c('div', {
    staticClass: "connect-button-buy connect-button-common",
    on: {
      "click": function ($event) {
        return _vm.onBuy(0);
      }
    }
  }, [_vm.isLoading ? [_c('svg-icon', {
    attrs: {
      "name": "icon-refresh",
      "spin": ""
    }
  })] : _vm._e(), _vm._v(" " + _vm._s(_vm.$lang(`Buy`)) + " ")], 2)])] : [_c('div', {
    staticClass: "content-button-wrapper",
    staticStyle: {
      "height": "100%"
    }
  }, [_c('div', {
    staticClass: "connect-button-buy connect-button-common",
    on: {
      "click": function ($event) {
        return _vm.onApprove();
      }
    }
  }, [_vm.isLoading ? [_c('svg-icon', {
    attrs: {
      "name": "icon-refresh",
      "spin": ""
    }
  })] : _vm._e(), _vm._v(" " + _vm._s(_vm.$lang(`Approve`)) + " ")], 2)])]]]], 2), _vm.nftSellInfo.userMint > 0 || _vm.userInfo && _vm.userInfo.user && _vm.userInfo.user.total_stake_nfts > 0 || _vm.userBurnAmount >= 500 ? _c('div', {
    directives: [{
      name: "copy",
      rawName: "v-copy",
      value: `${_vm.getHost}?t=${_vm.address}`,
      expression: "`${getHost}?t=${address}`"
    }],
    staticClass: "invite-box"
  }, [_c('span', [_vm._v(_vm._s(_vm.$lang(`Copy My Referral Link`)))]), _c('svg-icon', {
    attrs: {
      "name": "icon-copy"
    }
  })], 1) : _vm._e()] : [_c('div', {
    staticClass: "content-button-wrapper",
    staticStyle: {
      "height": "100%"
    }
  }, [_c('div', {
    staticClass: "connect-button-buy connect-button-common",
    on: {
      "click": _vm.doConnect
    }
  }, [_vm._v("Connect Wallet")])])]], 2)])])])]), _c('div', {
    staticClass: "s2"
  }, [_c('div', {
    staticClass: "s2-main"
  }, [_c('div', {
    staticClass: "s2-list"
  }, [_c('div', {
    staticClass: "s2-item item-1",
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function ($event) {
        return _vm.changeRecordDialog(true);
      }
    }
  }, [_c('div', {
    staticClass: "s2-item__icon"
  }, [_c('img', {
    attrs: {
      "src": require('@images/s2-icon-1.png')
    }
  })]), _c('div', {
    staticClass: "s2-item__info"
  }, [_c('div', {
    staticClass: "s2-item__label"
  }, [_vm._v(_vm._s(_vm.nftSellInfo.userMint))]), _c('div', {
    staticClass: "s2-item__title"
  }, [_vm._v(_vm._s(_vm.$lang(`My Nodes`)))])])]), _c('div', {
    staticClass: "s2-item item-2"
  }, [_c('div', {
    staticClass: "s2-item__icon"
  }, [_c('img', {
    attrs: {
      "src": require('@images/s2-icon-2.png')
    }
  })]), _c('div', {
    staticClass: "s2-item__info"
  }, [_c('div', {
    staticClass: "s2-item__label"
  }, [_vm._v(_vm._s(_vm.userTotalInviter))]), _c('div', {
    staticClass: "s2-item__title"
  }, [_vm._v(_vm._s(_vm.$lang(`Referral Person`)))])])]), _c('div', {
    staticClass: "s2-item item-3"
  }, [_c('div', {
    staticClass: "s2-item__icon"
  }, [_c('img', {
    attrs: {
      "src": require('@images/s2-icon-3.png')
    }
  })]), _c('div', {
    staticClass: "s2-item__info"
  }, [_c('div', {
    staticClass: "s2-item__label"
  }, [_vm._v(_vm._s(_vm._f("toThousands")(_vm.userTotalCommission)) + " USDT")]), _c('div', {
    staticClass: "s2-item__title"
  }, [_vm._v(_vm._s(_vm.$lang(`Referral Rewards`)))])])]), _c('div', {
    staticClass: "s2-item item-4"
  }, [_c('div', {
    staticClass: "s2-item__icon"
  }, [_c('img', {
    attrs: {
      "src": require('@images/s2-icon-4.png')
    }
  })]), _c('div', {
    staticClass: "s2-item__info"
  }, [_c('div', {
    staticStyle: {
      "display": "flex"
    }
  }, [_c('div', {
    staticClass: "s2-item__label"
  }, [_vm._v(_vm._s(_vm.userTotalAmount))]), _c('div', {
    staticStyle: {
      "flex-grow": "1"
    }
  }), _c('AutoBursh')], 1), _c('div', {
    staticClass: "s2-item__title"
  }, [_vm._v(" " + _vm._s(_vm.$lang(`Token`)) + " "), _c('div', {
    staticClass: "s3-item-btns"
  }, [_c('div', {
    staticClass: "s3-item-btn btn1",
    on: {
      "click": function ($event) {
        return _vm.viewOrder();
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$lang(`Record`)) + " ")]), _c('div', {
    staticClass: "s3-item-btn",
    on: {
      "click": function ($event) {
        return _vm.onClaim();
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$lang(`Apply`)) + " "), _vm.claimLoading ? [_c('svg-icon', {
    attrs: {
      "name": "icon-refresh",
      "spin": ""
    }
  })] : [_c('svg-icon', {
    attrs: {
      "name": "icon-arrow1"
    }
  })]], 2)])])])])])])]), _c('div', {
    staticClass: "rule"
  }, [_c('div', {
    staticClass: "rule-main"
  }, [_c('div', {
    staticClass: "rule__tabs"
  }, [_c('div', {
    staticClass: "tab",
    class: _vm.selectTab == 0 && 'active',
    on: {
      "click": function ($event) {
        return _vm.onSelectTab(0);
      }
    }
  }, [_vm._v(_vm._s(_vm.$lang('Node Intro')))]), _c('div', {
    staticStyle: {
      "flex-grow": "1"
    }
  }), _c('TotalOverview')], 1), _vm.selectTab == 0 ? _c('div', {
    staticClass: "rule__content"
  }, [_c('h2', [_vm._v(_vm._s(_vm.$lang('About Reflection Node')))]), _c('h3', [_vm._v(_vm._s(_vm.$lang('Node Sale Method:')))]), _c('h3', [_vm._v(_vm._s(_vm.$lang('Price Increment: ')))]), _c('ul', [_c('li', [_vm._v(" " + _vm._s(_vm.$lang(`For the first 2,000 Genesis NFTs, the price increases by 25 USDT every 100 NFTs sold.`)) + " ")]), _c('li', [_vm._v(" " + _vm._s(_vm.$lang(`After 2,000 NFTs are sold, the price increases by 25 USDT every 400 NFTs sold.`)) + " ")]), _c('li', [_vm._v(" " + _vm._s(_vm.$lang(`From 10,000 to 30,000 NFTs, the price increases by 25 USDT every 200 NFTs sold.`)) + " ")])]), _c('h3', [_vm._v(_vm._s(_vm.$lang('Purchase Limit:')) + " ")]), _c('ul', [_c('li', [_vm._v(_vm._s(_vm.$lang('Each address can purchase up to 10 Genesis NFTs.')))])]), _c('h3', [_vm._v(_vm._s(_vm.$lang('Referral Mechanism:')))]), _c('ul', [_c('li', [_vm._v(" " + _vm._s(_vm.$lang(`Referral Rewards:Genesis NFT holders receive 10%/1% rewards from the invited users’ purchases of Genesis NFTs, for a total of 11%, distributed across two levels.`)) + " ")])]), _c('h3', [_vm._v(_vm._s(_vm.$lang('Genesis NFT Benefits:')))]), _c('ul', [_c('li', [_vm._v(_vm._s(_vm.$lang(`Mining Rewards: All Genesis NFT investors can earn token rewards through mining activities.`)) + " ")]), _c('li', [_vm._v(_vm._s(_vm.$lang(`Whitelist Privileges: Access to IDO participation, WL permissions, exclusive airdrops, and other early-stage ecosystem project benefits.`)) + " ")]), _c('li', [_vm._v(" " + _vm._s(_vm.$lang(`Ecosystem Governance: Genesis NFT investors have governance rights, becoming early builders, contributors, and decision-makers.`)) + " ")])]), _c('h3', [_vm._v(_vm._s(_vm.$lang('Equity NFT Minting Mechanism:')))]), _c('ul', [_c('li', [_vm._v(" " + _vm._s(_vm.$lang('Equity NFTs will be minted in batches, mapped 1:1 to Genesis NFTs.')) + " ")]), _c('li', [_vm._v(" " + _vm._s(_vm.$lang('Pricing: 100 RECT')) + " ")]), _c('li', [_vm._v(" " + _vm._s(_vm.$lang('Transaction Fees: 25%-50%')) + " ")])]), _c('h3', [_vm._v(_vm._s(_vm.$lang('Income Example:')))]), _c('ul', [_c('li', [_vm._v(_vm._s(_vm.$lang('Holding 1 Genesis NFT: $100/month, $4,500 accumulated over 3 years.')))]), _c('li', [_vm._v(_vm._s(_vm.$lang('Holding 3 Genesis NFTs: $300/month, $13,500 accumulated over 3 years.')))])]), _c('h3'), _c('li', [_vm._v(" " + _vm._s(_vm.$lang('Genesis NFT holders can earn stable mining rewards and additional income through Equity NFT minting and trading.')) + " ")])]) : _vm._e()])])] : _vm._e(), _vm.homeActivateIndex == 1 ? [_c('div', {
    staticClass: "s1"
  }, [_c('div', {
    staticClass: "s1-main"
  }, [_c('div', {
    staticClass: "s1-left"
  }, [_c('div', {
    staticClass: "video-box"
  }, [_c('video', {
    attrs: {
      "autoplay": "",
      "loop": "",
      "muted": "",
      "playsinline": ""
    },
    domProps: {
      "muted": true
    }
  }, [_c('source', {
    attrs: {
      "src": require('@images/video.mp4'),
      "type": "video/mp4"
    }
  })])])]), _c('div', {
    staticClass: "s1-right"
  }, [_c('div', {
    staticClass: "node-record-line"
  }, [_c('div', {
    staticClass: "s1__title"
  }, [_vm._v(_vm._s(_vm.$lang(`映射NFT`)))]), _c('NodeRecord')], 1), _c('div', {
    staticClass: "s1-list"
  }, [_c('div', {
    staticClass: "s1-number"
  }, [_c('div', {
    staticClass: "btn-n",
    class: _vm.mapBuyNum <= 1 && 'dis',
    on: {
      "click": _vm.onMapMin
    }
  }, [_vm._v("MIN")]), _c('div', {
    staticClass: "btn-m",
    class: _vm.mapBuyNum <= 1 && 'dis',
    on: {
      "click": _vm.onMapSub
    }
  }, [_vm._v("-")]), _c('div', {
    staticClass: "s1-input"
  }, [_c('div', {
    staticClass: "s1-input-main"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.mapBuyNum,
      expression: "mapBuyNum"
    }],
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": _vm.mapBuyNum
    },
    on: {
      "keyup": function ($event) {
        return _vm.mapBuyNumKeyUp();
      },
      "input": function ($event) {
        if ($event.target.composing) return;
        _vm.mapBuyNum = $event.target.value;
      }
    }
  })])]), _c('div', {
    staticClass: "btn-m",
    class: _vm.isMapMax && 'dis',
    on: {
      "click": _vm.onMapAdd
    }
  }, [_vm._v("+")]), _c('div', {
    staticClass: "btn-n",
    class: _vm.isMapMax && 'dis',
    on: {
      "click": _vm.onMapMax
    }
  }, [_vm._v("Max")])]), _c('div', {
    staticClass: "s1-value"
  }, [_c('div', {
    staticClass: "s1-val"
  }, [_c('span', [_vm._v(_vm._s(_vm.$lang(`Total Amount: `)))]), _vm._v(_vm._s(_vm.mapPriceLabel) + " RECT")])]), _c('div', {
    staticClass: "btn-box"
  }, [_vm.address ? [!_vm.token_enough ? [_c('div', {
    staticClass: "btn-buy",
    on: {
      "click": function ($event) {
        return _vm.onMapBuy(1);
      }
    }
  }, [_vm._v(_vm._s(_vm.$lang(`RECT balance is insufficient`)))])] : [_vm.isApprove ? [_c('div', {
    staticClass: "content-button-wrapper",
    staticStyle: {
      "height": "100%"
    }
  }, [_c('div', {
    staticClass: "connect-button-buy connect-button-common",
    on: {
      "click": function ($event) {
        return _vm.onMapBuy(0);
      }
    }
  }, [_vm.isLoading ? [_c('svg-icon', {
    attrs: {
      "name": "icon-refresh",
      "spin": ""
    }
  })] : _vm._e(), _vm._v(" " + _vm._s(_vm.$lang(`Buy`)) + " ")], 2)])] : [_c('div', {
    staticClass: "content-button-wrapper",
    staticStyle: {
      "height": "100%"
    }
  }, [_c('div', {
    staticClass: "connect-button-buy connect-button-common",
    on: {
      "click": function ($event) {
        return _vm.onMapApprove();
      }
    }
  }, [_vm.isLoading ? [_c('svg-icon', {
    attrs: {
      "name": "icon-refresh",
      "spin": ""
    }
  })] : _vm._e(), _vm._v(" " + _vm._s(_vm.$lang(`Approve`)) + " ")], 2)])]]] : [_c('div', {
    staticClass: "content-button-wrapper",
    staticStyle: {
      "height": "100%"
    }
  }, [_c('div', {
    staticClass: "connect-button-buy connect-button-common",
    on: {
      "click": _vm.doConnect
    }
  }, [_vm._v("Connect Wallet")])])]], 2)])])])])] : _vm._e(), _vm.homeActivateIndex == 2 ? [_c('LayoutCenter'), _c('LayoutCenterRewards')] : _vm._e()], 2), _c('pop-prompt', {
    attrs: {
      "show": _vm.popInviterTipShow,
      "title": _vm.popTipContent,
      "showCancelBtn": false,
      "confirmTxt": _vm.$lang('Ok')
    },
    on: {
      "update:show": function ($event) {
        _vm.popInviterTipShow = $event;
      },
      "cancel": function ($event) {
        _vm.popInviterTipShow = false;
      },
      "confirm": function ($event) {
        _vm.popInviterTipShow = false;
      }
    }
  }), _c('pop-claim-orders', {
    attrs: {
      "show": _vm.popOrderShow
    },
    on: {
      "update:show": function ($event) {
        _vm.popOrderShow = $event;
      }
    }
  }), _c('invite-binding-dialog')], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };